import _ from 'lodash';
import {createSelector} from 'reselect';

import {AppParametricSelector} from '../../../helpers/reselectHelpers';
import {PrecogModel, PrecogStatusTypesEnum} from '../../../models/api/precogModel';
import {getAllActivities, getConversationPrecogs} from '../dataSelectors';
import {ConversationBaseSelector} from './conversationsSelectors';

export type PrecogsSelector<P> = AppParametricSelector<P, ReadonlyArray<PrecogModel>>;

export function makeGetPrecogs<P>(getConversation: ConversationBaseSelector<P>): PrecogsSelector<P> {
  return createSelector(
    [getConversation, getConversationPrecogs, getAllActivities],
    (conversation, conversationPrecogs, allActivities) =>
      _(conversationPrecogs[conversation.id] || [])
        // If we have a typing precog, show it.
        // If we have a sent precog, show it only if we don't yet have the corresponding activity.
        .filter(
          (precog) => precog.status === PrecogStatusTypesEnum.TYPING || !allActivities[precog.activityId],
        )
        .sortBy('teammateId')
        .value(),
  );
}
